import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { HAS_AUTHENTICATED_KEY } from '../../../lib/api-client';
import { logout } from '../api/auth.api';

import { AUTH_KEYS } from './useCurrentUser';

export function useLogout() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      // Reset the panel's session-only hidden state so it is visible again after the next login.
      sessionStorage.removeItem('floating-panel-closed');
      // A deliberate logout means the next 401 on this browser (e.g. someone else using a
      // shared machine) should not be reported as an "expired" session — see api-client.ts's
      // forceLogout().
      localStorage.removeItem(HAS_AUTHENTICATED_KEY);

      // removeQueries (not invalidate) — we know the user is logged out, no need to
      // refetch /auth/me again right before navigating away.
      queryClient.removeQueries({ queryKey: AUTH_KEYS.me });
      navigate('/login');
    },
  });
}
